import React, { useState } from 'react';
import Button from 'shared/components/Button';
import {
  ArrowLeftLargeIcon,
  ControlsIcon,
  LogoMediumIcon,
  PenIcon,
  Photo,
  PlusLargeIcon,
  SortIcon,
  TimesIcon,
} from 'shared/components/Icons';
import { useTranslation } from 'react-i18next';
import { shareTypesIcons } from 'configs';
import { useHistory } from 'react-router';
import { useLastLocation } from 'react-router-last-location';
import MobileSettingMenu from './MobileSettingMenu';
import Dropdown from 'shared/components/Dropdown';

const ProductsHeader = ({
  productsCount,
  project,
  onAddLikieeClick,
  onAddLikieeImageClick,
  organizeState,
  onOrganizeClick,
  onFilterClick,
  onEditProjectClick,
  onSortClick,
  disableFilterButton,
  disableSortButton,
  disableOrganizeButton,
  hasSelectedFilters,
}) => {
  const [dropMenu, setDropMenu] = useState(false);
  const history = useHistory();
  const lastLocation = useLastLocation();
  const { t } = useTranslation();
  const ShareTypeIcon = project && project.visibility && shareTypesIcons[project.visibility];

  const goBack = () => {
    // If there's a last location and it's not the auth page, go back
    if (lastLocation && !lastLocation.pathname.includes('/auth')) {
      history.goBack();
    } else {
      // Otherwise go to dashboard
      history.push('/dashboard');
    }
  };

  return (
    <div className='d-flex align-items-center justify-content-between mb-10 mb-md-15'>
      <div>
        <h1 className='d-flex align-items-center mb-0 mb-md-3'>
          <button className='btn p-0 mr-5' onClick={goBack}>
            <ArrowLeftLargeIcon />
          </button>
          <span>{project?.name || t('text_all_likiees')}</span>
          {project?.visibility && (
            <div className='action-btn ml-10 d-flex align-items-center justify-content-center'>
              <ShareTypeIcon />
            </div>
          )}
        </h1>
        <p className='mb-0 text-gray-dark pl-23 d-none d-md-block'>
          {productsCount} {t('text_products')}
        </p>
      </div>
      <div className='d-none d-md-flex align-items-center justify-content-start justify-content-md-end mb-8 mb-md-15'>
        <Dropdown
          className='ml-8 ml-md-16'
          contentClassName='no-separator mt-6 py-1 dash-add-drop-menu justify-content-between'
          withPortal={false}
          outStateOpen={dropMenu}
          setOutStateOpen={setDropMenu}
          toggleContent={isOpened => (
            <Button
              className={`btn-sm d-flex no-transition align-items-center px-8 py-2 py-md-4 ${
                isOpened ? 'btn-dark' : 'btn-outline-dark'
              }`}
            >
              <PlusLargeIcon className='mr-5' />
              {t('btn_add')}
            </Button>
          )}
        >
          <div className='px-8'>
            <Dropdown.Item
              className='d-flex text-nowrap align-items-center px-0 border-bottom onboarding-sel-add-likiee'
              onClick={onAddLikieeClick}
            >
              <LogoMediumIcon className='mr-5 svg-gray min-icon' width='24' height='24' />
              <span className='text-ellipsis text-md'>{t('btn_add_likiee')}</span>
            </Dropdown.Item>
            <Dropdown.Item
              className='d-flex text-nowrap px-0 align-items-center onboarding-sel-add-project'
              onClick={onAddLikieeImageClick}
            >
              <Photo className='mr-5 svg-gray min-icon' width='24' height='24' />
              <span className='text-ellipsis text-md'>{t('btn_add_likiee_photo')}</span>
            </Dropdown.Item>
          </div>
        </Dropdown>
        {!project && (
          <Button
            className='btn-sm btn-outline-dark d-flex align-items-center ml-md-16 px-8 py-2 py-md-4'
            onClick={onOrganizeClick}
            disabled={disableOrganizeButton}
          >
            {organizeState ? <TimesIcon className='mr-5' /> : <ControlsIcon className='mr-5' />}
            {t('btn_organize')}
          </Button>
        )}
        <Button
          className={`btn-sm d-flex align-items-center ml-8 ml-md-16 px-8 py-2 py-md-4 ${
            hasSelectedFilters ? 'btn-primary svg-white' : 'btn-outline-dark'
          }`}
          onClick={onFilterClick}
          disabled={disableFilterButton}
        >
          <ControlsIcon className='mr-5' />
          {t('btn_filter')}
        </Button>
        {!!project && (
          <Button
            className='btn-sm btn-outline-dark d-flex align-items-center ml-8 ml-md-16 px-8 py-2 py-md-4'
            onClick={onEditProjectClick}
          >
            <PenIcon className='mr-5' />
            {t('btn_edit_project')}
          </Button>
        )}
        <Button
          className='btn-sm btn-outline-dark d-flex align-items-center ml-8 ml-md-16 px-8 py-2 py-md-4'
          onClick={onSortClick}
          disabled={disableSortButton}
        >
          <SortIcon className='mr-5' />
          {t('btn_sorting')}
        </Button>
      </div>
      <div className='d-block d-md-none'>
        <MobileSettingMenu
          onFilterClick={onFilterClick}
          disableFilterButton={disableFilterButton}
          onSortClick={onSortClick}
          disableSortButton={disableSortButton}
          project={project}
          onEditProjectClick={onEditProjectClick}
        />
      </div>
    </div>
  );
};

export default ProductsHeader;
